<script>
import { Input } from 'ant-design-vue'
export default {
  props: ['value', 'item'],
  data() {
    return {
      data: [],
    }
  },
  watch: {
    value() {
      if (this.data === this.value) return
      this.data = this.value || []
    },
  },
  mounted() {
    this.data = this.value || []
  },
  methods: {
    onClose(e, i) {
      e.stopPropagation()
      this.data.splice(i, 1)
      this.$emit('change', this.data)
      // this.item.onChange && this.item.onChange(this.data)
    },
  },
  render() {
    return (
      <div class="selectBox" onClick={() => this.item.onClick && this.item.onClick()}>
        {this.data.length ? (
          this.data.map((e, i) => {
            return (
              <div class="select-li">
                {e[this.item.selectLable || 'name']} <span onClick={(ev) => this.onClose(ev, i)}>×</span>
              </div>
            )
          })
        ) : (
          <span>{this.item.placeholder || '请选择'}</span>
        )}
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
.selectBox {
  position: relative;
  min-height: 32px;
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  margin-top: 4px;
  padding: 2px 4px 4px;
  display: flex;
  flex-wrap: wrap;
  > span {
    color: #bfbfbf;
    line-height: 20px;
    margin-top: 2px;
    margin-left: 4px;
    white-space: nowrap;
  }
}
.select-li {
  max-width: 99%;
  margin-right: 4px;
  padding: 0 10px;
  padding-right: 7px;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  cursor: default;
  height: 24px;
  margin-top: 2px;
  line-height: 22px;
  > span {
    font-size: 18px;
    cursor: pointer;
  }
}
</style>